/* ============================================================
   THEME.JS — Terrell Green Official Store
   ============================================================ */
(function () {
  'use strict';

  /* ── Mobile Nav ── */
  function initMobileNav() {
    var btn = document.getElementById('site-hamburger');
    var drawer = document.getElementById('mobile-nav-drawer');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      btn.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.addEventListener('click', function (e) {
      if (!btn.contains(e.target) && !drawer.contains(e.target)) {
        drawer.classList.remove('open');
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Filter Pills (visual, collection URL handled by Shopify) ── */
  function initFilterPills() {
    document.querySelectorAll('.filter-pills').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.filter-pill');
        if (!pill) return;
        group.querySelectorAll('.filter-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
      });
    });
  }

  /* ── Size Selector (featured product) ── */
  function initSizeSelector() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.featured-product__size-btn');
      if (!btn) return;
      var row = btn.closest('.featured-product__sizes');
      if (!row) return;
      row.querySelectorAll('.featured-product__size-btn').forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
    });
    // Product page option buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-page__option-btn');
      if (!btn) return;
      var group = btn.closest('.product-page__option-values');
      if (!group) return;
      group.querySelectorAll('.product-page__option-btn').forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
    });
  }

  /* ── Cart Count ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ── Quick Add ── */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-card__quick-add');
      if (!btn) return;
      var card = btn.closest('[data-variant-id]');
      if (!card) return;
      var variantId = card.dataset.variantId;
      if (!variantId) return;
      var orig = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.textContent = orig; btn.disabled = false; });
    });
  }

  /* ── Featured Product Add to Cart ── */
  function initFeaturedATC() {
    var atcBtn = document.querySelector('.featured-product__btn--main');
    if (!atcBtn) return;
    atcBtn.addEventListener('click', function () {
      var selected = document.querySelector('.featured-product__size-btn.selected');
      var variantId = atcBtn.dataset.variantId || (selected && selected.dataset.variantId);
      if (!variantId) {
        // Prompt size selection
        var sizes = document.querySelectorAll('.featured-product__size-btn');
        if (sizes.length > 0) { sizes[0].focus(); }
        return;
      }
      var orig = atcBtn.textContent;
      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          atcBtn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(function () { atcBtn.textContent = orig; atcBtn.disabled = false; }, 2000);
        })
        .catch(function () { atcBtn.textContent = orig; atcBtn.disabled = false; });
    });
  }

  /* ── Email Signup ── */
  function initEmailSignup() {
    document.querySelectorAll('.email-signup__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('.email-signup__input');
        var btn = form.querySelector('.email-signup__btn');
        if (!input || !input.value) return;
        var orig = btn.textContent;
        btn.textContent = 'Subscribing…';
        btn.disabled = true;
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=✓&contact[email]=' + encodeURIComponent(input.value) + '&contact[tags]=newsletter'
        })
          .then(function () {
            btn.textContent = 'Subscribed ✓';
            input.value = '';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 3000);
          })
          .catch(function () { btn.textContent = orig; btn.disabled = false; });
      });
    });
  }

  /* ── Header shadow on scroll ── */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 2px 20px rgba(17,17,16,0.08)' : '';
    }, { passive: true });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initFilterPills();
    initSizeSelector();
    initQuickAdd();
    initFeaturedATC();
    initEmailSignup();
    initHeaderScroll();
    updateCartCount();
  });

})();